// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__NFh8t","footerContainer":"footer_footerContainer__jMpiv","footerLeft":"footer_footerLeft__rSt7_","menu":"footer_menu__e0zgA"};